<div class="footer">
    <div>{{ date | date:'yyyy'}} LEASE FOR U</div>
    <div>Versión {{version}} {{ env ? ' - ' + env : ''}}</div> 
    <div></div>
</div>
